import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import Footer from '../../Components/Menu/Footer';
import { COR_PRINCIPAL_DEFAULT } from '../../constants';

const LinkPagamentoAguardandoConciliacao: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        background: `linear-gradient(
          145deg,
          ${alpha(theme.palette.grey[100], 0.9)} 0%,
          ${alpha(COR_PRINCIPAL_DEFAULT, 0.05)} 100%
        )`,
        position: 'relative',
        overflow: 'hidden',
        py: { xs: 4, md: 8 }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          height: 280,
          background: `linear-gradient(135deg, ${COR_PRINCIPAL_DEFAULT} 0%, ${alpha(
            COR_PRINCIPAL_DEFAULT,
            0.85
          )} 100%)`,
          clipPath: 'polygon(0 0, 100% 0, 100% 65%, 0 100%)',
          zIndex: 0
        }}
      />

      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
        <Paper
          elevation={6}
          sx={{
            borderRadius: 4,
            textAlign: 'center',
            p: { xs: 4, md: 6 },
            backdropFilter: 'blur(4px)'
          }}
        >
          <HourglassEmptyIcon
            sx={{
              fontSize: 64,
              color: theme.palette.warning.main,
              mb: 2
            }}
          />

          <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
            Aguardando conciliação
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            O pagamento desta cobrança foi identificado e está aguardando conciliação. Não é
            necessário realizar um novo pagamento.
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Em caso de dúvidas, entre em contato com o emissor da fatura.
          </Typography>
        </Paper>

        <Footer backgroundColor="transparent" />
      </Container>
    </Box>
  );
};

export default LinkPagamentoAguardandoConciliacao;
